let selectedItems = new Map();

function selectable(node, params) {
  if (!params) {
    params = {};
  }

  node.addEventListener('mouseenter', handleMouseEnter);
  node.addEventListener('mouseleave', handleMouseLeave);

  function handleMouseEnter(event) {
    node.classList.add('hover-in');
    node.dispatchEvent(
      new CustomEvent('hoverIn', {
        detail: {
          event,
        },
      })
    );
    event.preventDefault();
    event.stopPropagation();

    node.addEventListener('mousedown', handleMouseDown);
    node.addEventListener('mouseup', handleMouseUp);
  }

  function handleMouseLeave(event) {
    node.classList.remove('hover-in');
    node.removeEventListener('mousedown', handleMouseDown);
    node.removeEventListener('mouseup', handleMouseUp);
  }

  function handleMouseDown(event) {
    event.preventDefault();
    const existing = selectedItems.get(params.item.id);
    if (!existing) {
      if (node.tagName === 'HEADER') {
        selectedItems.set(params.item.id, node.parentElement);
      } else {
        selectedItems.set(params.item.id, node);
      }
    }

    node.dispatchEvent(
      new CustomEvent('mouseDown', {
        detail: {
          event,
          selectedItems,
        },
      })
    );
  }

  function handleMouseUp(event) {
    event.preventDefault();
    node.dispatchEvent(new CustomEvent('mouseUp', {}));
  }

  return {
    destroy() {
      node.removeEventListener('nouseenter', handleMouseEnter);
      node.removeEventListener('mouseleave', handleMouseLeave);
    },
  };
}

export { selectable };
